/* eslint-disable */
// author: wangk2
// latest: zhangmyh 2017-3-22 4:15 PM
import 'ko-epui/dist/ko-epui.css'
import 'ko-epui'

import ko from 'knockout'

import 'ucloud-ko-fileupload/dist/index.css'
import 'ucloud-ko-fileupload'

import 'components'
import { debounce } from 'lodash'
import biddingApply from 'model/biddingApply/_index'
import bidpromise from 'model/biddingApply/bid_promise'
import uMessage from 'components/message'
import Countdown from 'components/countdown'
import 'components/countdown/countdown.css'
import 'static/vendor/tweenmax'
import './format.js'
import {Get} from 'common'
import {GetChecked} from './io.js'
import './index.less'
/* global ko __ $ */

(async function () {
  $.ajax({
    url: '/yuncai/ebvplogin',
    type: 'get',
    dataType: 'json',
    error: function (data) {
      if (data.status == '306') {
        window.u.confirmDialog({
          msg: '登录超时，请尝试重新登录!',
          width: '500px',
          title: '登录信息超时提示',
          onOk: function (msg) {
            viewModel.sign()
          }
        })
      }
    }
  })
})()
var id = window.global.query('id')
id = id || window.global.query('tradeid')
var from = window.global.query('from')
let trade = biddingApply.trade
trade.load({ tradeid: id })
// bidpromise.load({ bidtradeID: id, enterpriseId: window.global.user.enterpriseId })
bidpromise.load({ bidtradeID: id})

trade.on('data', function (data) {
  var ret = data.registEndTime
  var red = new Date()
  red.setTime(ret)
  var res = red.format('yyyy/MM/dd HH:mm:ss')
  Countdown.init('#timer', res)
  var bst = data.bidStartTime
  var bsd = new Date()
  bsd.setTime(bst)
  var bss = bsd.format('yyyy/MM/dd HH:mm:ss')
  viewModel.registEndTime(res)
  viewModel.bidStartTime(bss)
  if (!data.supCertificateRequire || data.supCertificateRequire == 0) {
    viewModel.supCertificateRequire(false)
    viewModel.fivecard(false)
    viewModel.threecard(false)
    viewModel.model.setValue('supCertificateRequire', null)
  } else {
    viewModel.supCertificateRequire(true)
    viewModel.threecard(true)
    viewModel.model.setValue('supCertificateRequire', 1)
    viewModel.model_pm.setValue('supCertificateRequire', 1)
  }
})
trade.datatable.on('supCertificateRequire.valueChange', function (value) {
  if (value.newValue == 1) {
    viewModel.threecard(true)
    viewModel.fivecard(false)
    viewModel.model_pm.setValue('supCertificateRequire', 1)
  } if (value.newValue == 2) {
    viewModel.fivecard(true)
    $('#uploader_bidtrade_four-4').children().eq(1).css({'width': '20px', 'height': '20px'})
    $('#uploader_bidtrade_five-5').children().eq(1).css({'width': '20px', 'height': '20px'})
    $('#uploader_bidtrade_six-6').children().eq(1).css({'width': '20px', 'height': '20px'})
    $('#uploader_bidtrade_seven-7').children().eq(1).css({'width': '20px', 'height': '20px'})
    $('#uploader_bidtrade_eight-8').children().eq(1).css({'width': '20px', 'height': '20px'})
    viewModel.threecard(false)
    viewModel.model_pm.setValue('supCertificateRequire', 2)
  }
})

var viewModel = {
  id: ko.observable(),
  fs_1: ko.observable(0),
  fs_2: ko.observable(0),
  fs_3: ko.observable(0),
  fs_4: ko.observable(0),
  fs_5: ko.observable(0),
  fs_6: ko.observable(0),
  fs_7: ko.observable(0),
  fs_8: ko.observable(0),
  modalVisible: ko.observable(false),
  checkButton: ko.observable(true),
  threecard: ko.observable(false),
  fivecard: ko.observable(false),
  supCertificateRequire: ko.observable(false),
  promisStatus: ko.observable(true),
  registEndTime: ko.observable(''),
  bidStartTime: ko.observable(''),
  // 数据
  model: trade.datatable,
  model_pm: bidpromise.datatable,
  // 证件要求
  certificateRequire: [{value: '1', name: '三证合一'}, {value: '2', name: '传统'}],
  // 税务发票信息
  taxinvoicedata: [{value: '0', name: '不提供'}, {value: '1', name: '普通发票'}, {value: '2', name: '增值税发票'}],
  // 保存
  save: debounce(async function () {
    $('#msgBtn').attr('disabled', true)
    $('#msgBtn').removeClass('btn-primary')
    var data = await bidpromise.save()
    if (data.status == '1') {
      uMessage('success', data.msg || '保存成功')
    } else {
      uMessage('fail', data.msg || '保存失败')
    }
    $('#saveId').removeAttr('disabled', true)
    $('#saveId').addClass('btn-primary')
  }, 300, { maxWait: 2000 }),
  // 报名
  sign: debounce(async function () {
    //var projectId = window.app.dataTables.model.getSimpleData()[0].id
    //var enterpriseId = window.app.dataTables.model.getSimpleData()[0].enterpriseId
    var data = await GetChecked('/cpu-bidauction/bidtrade/getBidTradebyIdforsup?id='+id,from);
    
    if(data.msg){
      uMessage('fail',data.msg);
    }else{
      var check=await Get('/yuncai/supBaseDoc/for-sale/checkSupBid?purEnterpriseId='+data.data.enterpriseId);
      if(check.status==1){
        window.location.href='../biddingApply/index.zh_CN.html?id='+id
      }else{
        uMessage('fail',check.msg);
      }
    }
                   
    /*if (localStorage.name || localStorage.user) {
      var str = window.location.href
      str = str.replace('bidding_Apply', 'biddingApply')
      window.location.href = str
    } else {
      window.location.href = '/yuncai/portal'
    }*/


  }, 300, { maxWait: 2000 }),


  detail_grid: {
    'id': 'detail_grid',
    'data': trade.associations.bidtradeMaterialList,
    'type': 'grid',
    'multiSelect': false,
    'editable': false,
    canDrag: false,
    canSwap: false,
    columnMenu: false,
    autoWidth: true,
    fields: [
      {'field': 'materialClassName', 'dataType': 'String', 'title': '商品分类', 'width': '220'},
      {'field': 'materialName', 'dataType': 'String', 'title': '商品信息', 'width': '125'},
      {'field': 'num', 'dataType': 'String', 'title': '数量', 'sumCol': true, 'width': '125'},
      {'field': 'unit', 'dataType': 'String', 'title': '单位', 'width': '125'},
      {'field': 'note', 'dataType': 'String', 'title': '物商品描述', 'width': '150'},
      {'field': 'reqOrgName', 'dataType': 'String', 'title': '货权组织', 'width': '125'},
      {'field': 'reqTime', 'dataType': 'String', 'title': '需求时间', 'width': '150'},
      {'field': 'address', 'dataType': 'String', 'title': '交货地址', 'width': '150'}
    ]
  }
}
window.global.query('check')=='17'||window.global.query('check')=='3'?viewModel.checkButton(false):viewModel.checkButton(true)
window.app = window.u.createApp({
  el: 'body',
  model: viewModel
})



// WEBPACK FOOTER //
// ./src/pages/bidding_Apply/index.js